import { baseConfig } from '@moniebook-web/utils';
import { REGISTERS_API_URL } from '@register-ui/utils';
import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const MAX_TIME_DIFFERENCE_MINUTES = 2;
const FORMAT = 'MMM DD, YYYY · hh:mm A';

export async function validateDeviceTime() {
    const baseUrl = baseConfig.MONIEBOOK_SERVICE_URL;

    const response = await axios.get(
        `${baseUrl}${REGISTERS_API_URL.REGISTER.DATE_TIME}`,
    );

    if (!response.data.utcDatetime) {
        return { shouldBlockUser: false };
    }

    const serverTimestamp = dayjs.utc(response.data.utcDatetime).valueOf();
    const localTimestamp = dayjs().valueOf();

    const deviceTimeDisplay = dayjs.utc(localTimestamp).format(FORMAT);
    const serverTimeDisplay = dayjs.utc(serverTimestamp).format(FORMAT);

    const diffMs = Math.abs(localTimestamp - serverTimestamp);
    const diffMinutes = diffMs / (1000 * 60);

    return {
        shouldBlockUser: diffMinutes > MAX_TIME_DIFFERENCE_MINUTES,
        timeInfo: { device: deviceTimeDisplay, server: serverTimeDisplay },
    };
}
